import { useRouter } from 'next/router'
import { useQuery } from 'react-query'
import { getUserProfileService, getFavoritesService, getSocialMedia } from 'services/profile'
import Cookies from 'universal-cookie'
import useSession from './session'

function getCookies() {
  const cookies = new Cookies()
  return cookies.getAll()
}

export function useSocialMedia() {
  const { token } = useSession()
  return useQuery(
    'GET_SOCIAL_MEDIA',
    () => getSocialMedia({ token }),
    {
      enabled: !!token,
      cacheTime: Infinity,
      initialData: () => ({
        info: {
          discord_username: '',
          github_username: '',
          github_token: '',
        },
      }),
      refetchOnWindowFocus: false,
    },
  )
}

export function useProfile() {
  const router = useRouter()
  const {
    user_token: token,
  } = getCookies()
  return useQuery(
    'GET_PROFILE',
    () => getUserProfileService({ token }),
    {
      enabled: !!token,
      cacheTime: Infinity,
      onSuccess: ({ first_name, last_name }) => {
        if (!first_name || !last_name) {
          router.push('/registro?completeAccount=true')
        }
      },
      initialData: () => ({
        info: {
          discord_username: '',
          github_username: '',
          github_token: '',
        },
      }),
      refetchOnWindowFocus: false,
    },
  )
}

export function useFavorites() {
  const { token } = useSession()
  return useQuery(
    'GET_FAVORITES',
    () => getFavoritesService({ token }),
    {
      cacheTime: Infinity,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
    },
  )
}
